import React, { Component } from "react";
import SliderComponent from './../components/slider';
import CalculationComponent from './../components/calculation';
import FinanceOptionComponent from './../components/financeoptions';
import KonutProjectsComponent from './../components/konutprojects';
//import MortgageVideoComponent from './../components/mortgageHomeVideo';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Fade } from 'react-reveal';
import MetaTags from 'react-meta-tags';

class Home extends Component {
  render() {
    return (
      <>
        <MetaTags>
          <title>Emlak Katılım Mortgage</title>
          <meta name="robots" content="all" />
          <meta name="description" content="Hayalini kurduğunuz evi bulun. Tapusuyla beraber size en yakın Emlak Katılım Bankası şubesine gelin yada online olarak istediğiniz an başvurunuzu gerçekleştirin." />
          <meta property="og:title" content="Emlak Katılım Mortgage" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://mortgage.emlakkatilim.com.tr/" />
          <meta property="og:image" content="/content/images/seo/emlak-logo-facebook-size.jpg" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:description" content="Hayalini kurduğunuz evi bulun. Tapusuyla beraber size en yakın Emlak Katılım Bankası şubesine gelin yada online olarak istediğiniz an başvurunuzu gerçekleştirin." />
          <meta property="twitter:card" content="summary" />
          <meta property="twitter:site" content="@tremlakkatilim" />
          <meta property="twitter:title" content="Emlak Katılım Mortgage" />
          <meta property="twitter:url" content="https://mortgage.emlakkatilim.com.tr/" />
          <meta property="twitter:image" content="/content/images/seo/emlak-logo-twitter-size.jpg" />
          <meta property="twitter:description" content="Hayalini kurduğunuz evi bulun. Tapusuyla beraber size en yakın Emlak Katılım Bankası şubesine gelin yada online olarak istediğiniz an başvurunuzu gerçekleştirin." />
        </MetaTags>
        <section style={{ minHeight: "600px" }}>
          <SliderComponent />
        </section>
        <section style={{ overflow: "hidden" }}>
          <Container fluid>
            <Row>
              <Col className="calculationComponent d-flex align-items-center justify-content-center" sm={6}>
                <div className="w-100">
                  <Fade left>
                    <CalculationComponent />
                  </Fade>
                </div>
              </Col>
              <Col className="financeOptions d-flex align-items-center justify-content-center" sm={6}>
                <div className="w-100 pb-4">
                  <Fade right>
                    <FinanceOptionComponent />
                  </Fade>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* <section>
          <Fade bottom delay={500}>
            <MortgageVideoComponent />
          </Fade>
        </section> */}
        <section>
          <KonutProjectsComponent />
        </section>
      </>
    );
  }
}

export default Home;